<template>
    <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24 1C24.9763 1.97631 24.9763 3.55922 24 4.53553L12.4749 16.0607C11.3033 17.2322 9.40381 17.2322 8.23224 16.0607L1.35355 9.18198C0.377243 8.20567 0.377243 6.62276 1.35355 5.64645V5.64645C2.32986 4.67014 3.91277 4.67013 4.88909 5.64644L10.3536 11.1109L20.4645 1C21.4408 0.0236894 23.0237 0.0236894 24 1V1Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: "SVGChecked2"
}
</script>

<style scoped>

</style>
